export interface FlowStatusMessage {
  type: 'flow_status'
  status:
    | 'call_skipped'
    | 'free_call_scheduled'
    | 'paid_call_scheduled'
    | 'insurance_supported'
    | 'insurance_not_supported'
    | 'flow_exited'
    | 'user_signed_up'
}

export interface ErrorMessage {
  type: 'error'
  error: string
}

export type CrossOriginMessage = FlowStatusMessage | ErrorMessage

const sendMessage = (message: CrossOriginMessage) => {
  try {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(message))
    } else {
      window.parent.postMessage(JSON.stringify(message), '*')
    }

    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.log('Cross origin message sent:', message)
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to send Cross origin message:', error)
  }
}

export const notifyCallSkipped = () => {
  sendMessage({
    type: 'flow_status',
    status: 'call_skipped'
  })
}

export const notifyFlowExited = () => {
  sendMessage({
    type: 'flow_status',
    status: 'flow_exited'
  })
}

export const notifyFreeCallScheduled = () => {
  sendMessage({
    type: 'flow_status',
    status: 'free_call_scheduled'
  })
}

export const notifyPaidCallScheduled = () => {
  sendMessage({
    type: 'flow_status',
    status: 'paid_call_scheduled'
  })
}

export const notifyInsuranceSupported = () => {
  sendMessage({
    type: 'flow_status',
    status: 'insurance_supported'
  })
}

export const notifyInsuranceNotSupported = () => {
  sendMessage({
    type: 'flow_status',
    status: 'insurance_not_supported'
  })
}

export const notifyUserSignedUp = () => {
  sendMessage({
    type: 'flow_status',
    status: 'user_signed_up'
  })
}

export const sendError = (error: string) => {
  sendMessage({
    type: 'error',
    error
  })
}
